import { createSelector } from 'reselect';
import {
  hasViewAdminMenu,
  hasViewScreenOrgPlanOverview,
} from 'selectors/permissions';
import { getIsCompanyAdmin, getIsSuperAdmin } from 'selectors/loggedInUser';
import { getIsOnFreePlan } from 'selectors/featureToggles';
import getAdminNav from './admin';

export const showPlanOverviewInPlaceOfAdmin = createSelector(
  [
    getIsOnFreePlan,
    getIsCompanyAdmin,
    getIsSuperAdmin,
    hasViewAdminMenu,
    hasViewScreenOrgPlanOverview,
  ],
  (
    isOnFreePlan,
    isCompanyAdmin,
    isSuperAdmin,
    hasAdminMenuPermission,
    hasPlanOverviewPermission,
  ) =>
    isOnFreePlan &&
    !isCompanyAdmin &&
    !isSuperAdmin &&
    !hasAdminMenuPermission &&
    hasPlanOverviewPermission,
);

export const showSettingsInPlaceOfAdmin = createSelector(
  [
    getIsOnFreePlan,
    getIsCompanyAdmin,
    getIsSuperAdmin,
    hasViewAdminMenu,
    showPlanOverviewInPlaceOfAdmin,
  ],
  (isOnFreePlan, isCompanyAdmin, isSuperAdmin, hasAdminMenuPermission) =>
    isOnFreePlan &&
    !isCompanyAdmin &&
    !isSuperAdmin &&
    (hasAdminMenuPermission || showPlanOverviewInPlaceOfAdmin),
);

export const getSettingsNav = createSelector([getAdminNav], adminNav => {
  const navItemGroup = [];

  adminNav.forEach(section => {
    const newItems = section.items.filter(item => item.showInSettings);
    if (newItems.length) {
      navItemGroup.push({ ...section, items: newItems });
    }
  });

  return navItemGroup;
});
